{
  "version": 1,
  "keys": [
    {
      "keyId": "kg-platform-core-ed25519-local-1",
      "publicKeyPem": "-----BEGIN PUBLIC KEY-----\nMCowBQYDK2VwAyEA2XGw1rvLXYVOPy6VYnt2hCRo99jdW2fvV4jALRiRumw=\n-----END PUBLIC KEY-----",
      "algorithm": "ed25519",
      "createdAt": "2026-02-23T03:13:35.545Z"
    },
    {
      "keyId": "platform-bundle-ed25519-v1",
      "publicKeyPem": "-----BEGIN PUBLIC KEY-----\nMCowBQYDK2VwAyEA4H09s21qmjf4rgy9rpd2+tIFfiwrNzj1WeZ/uwnoYw4=\n-----END PUBLIC KEY-----\n",
      "algorithm": "ed25519",
      "createdAt": "2026-03-06T04:59:42.257Z"
    }
  ]
}
